.Stepper {
  --grid: ;
  --border-color: var(--neutral-1);
  --color: var(--primary);

  display: grid;
  grid: var(--grid);
  column-gap: var(--space-md);

  .StepperWrapper {
    z-index: 1;
    position: relative;
    overflow: hidden;
    display: grid;
    grid: auto / max-content auto max-content;
    width: fit-content;
    border-radius: var(--radius-xs);
    border: 1px solid var(--border-color);
    background: var(--white);
    transition: border-color 150ms;
  }

  .StepperWrapper:hover,
  .StepperWrapper:focus-within {
    --border-color: var(--neutral-hover);
    --color: var(--neutral);
    box-shadow: var(--smooth-shadow);
  }

  .StepperWrapper:has(button:active) {
    --border-color: var(--neutral);
  }

  &:has(label) {
    --grid: auto / max-content 1fr;
  }

  [data-slot="error"] {
    grid-column: 1 / -1;
    margin-top: var(--space-xs);
  }

  label {
    place-self: center start;
    color: var(--primary);
    font-size: 0.9375rem;
  }

  button {
    position: relative;
    align-self: stretch;
    cursor: pointer;
    border: none;
    padding: 0 2px;
    background-color: transparent;
    transition: background-color 250ms;
    color: var(--neutral-1);

    &:hover {
      background-color: var(--neutral-hover);
    }

    &:focus-visible {
      outline: 2px solid var(--focus);
      outline-offset: -1px;
    }

    &:first-of-type:focus-visible {
      border-top-left-radius: var(--radius-xs);
      border-bottom-left-radius: var(--radius-xs);
    }

    &:last-of-type:focus-visible {
      border-top-right-radius: var(--radius-xs);
      border-bottom-right-radius: var(--radius-xs);
    }

    &:active {
      background-color: var(--neutral);
      span {
        background-position-x: -40px;
      }
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
}

.InputWrapper {
  border: solid var(--border-color);
  border-width: 0 1px;
  color: var(--color);
  font-weight: 500;
  text-align: center;
  transition:
    border-color 150ms,
    color 150ms;

  input {
    min-width: 1rem;
    max-width: 3rem;
    opacity: 0;
    border: none;
    padding: var(--space-xs);
  }

  &:has(input:focus-visible) {
    z-index: 3;
    outline: 2px solid var(--focus);
    outline-offset: -1px;
  }
}
